'use strict';

import _ from 'lodash';
import UrlWindow from './UrlWindow';

export default class Paginator {
    constructor(location, total, perPage, currentPage, pageName = 'start') {
        this.location = location;
        this.onEachSide = 3;
        this.total = total;
        this.perPage = perPage;
        this.lastPageValue = Math.max(~~Math.ceil(total / perPage), 1);
        this.currentPageValue = this.setCurrentPage(currentPage);
        this.pageName = pageName;
    }

    setCurrentPage(currentPage) {
        return currentPage > 0 ? ~~currentPage : 1;
    }

    lastPage() {
        return this.lastPageValue;
    }

    currentPage() {
        return this.currentPageValue;
    }

    getUrlRange(start, end) {
        return _.reduce(
            _.range(start, end + 1),
            (iteratee, page, index) => {
                iteratee.push({page, url: this.url(page)});
                return iteratee;
            },
            []
        );
    }

    setQuery(query) {
        this.query = _.reduce(
            query,
            (iteratee, value, key) => {
                iteratee[value[0]] = value[1];
                return iteratee;
            },
            {}
        );

        return this;
    }

    hasPages() {
        return this.currentPage() != 1 || this.hasMorePages();
    }

    hasMorePages() {
        return this.currentPage() < this.lastPage();
    }

    onFirstPage() {
        return this.currentPage() <= 1;
    }

    previousPageUrl() {
        if (this.currentPage() > 1) {
            return this.url(this.currentPage() - 1);
        }
    }

    nextPageUrl() {
        if (this.lastPage() > this.currentPage()) {
            return this.url(this.currentPage() + 1);
        }
    }

    url(page) {
        if (page <= 0) {
            page = 1;
        }

        // If we have any extra query string key / value pairs that need to be added
        // onto the URL, we will put them in query string form and then attach it
        // to the URL. This allows for extra information like sortings storage.
        let parameters = {[this.pageName]: page};

        if (page === 1) {
            // Don't add page param if page is 1
            parameters = {};
        }

        if (this.query && this.query.length > 0) {
            parameters = {...parameters, ...this.query};
        }

        let url = this.location.pathname;

        url += url.indexOf('?') !== -1 ? '&' : '?';

        url += Object.keys(parameters)
            .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(parameters[key]))
            .join('&');

        return url;
    }

    elements() {
        const window = new UrlWindow(this).get(this.onEachSide);

        return _.filter(
            [
                window.first,
                _.isObjectLike(window.slider) ? '...' : null,
                window.slider,
                _.isObjectLike(window.last) ? '...' : null,
                window.last,
            ],
            item => !!item
        );
    }
}
